import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Accordion from 'react-bootstrap/Accordion';
import authService from '../../services/AuthService';

import './NavMenu.css';

import understandingSM from '../../content/UnderstandingSM.png';
import learningSM from '../../content/LearningSM.png';
import communicatingSM from '../../content/CommunicatingSM.png';
import socializingSM from '../../content/SocializingSM.png';
import dailyLivingSM from '../../content/DailyLiving.png';
import movingSensingSM from '../../content/MovingSensingSM.png';
import focusingSM from '../../content/FocusingSM.png';
import rememberingSM from '../../content/RememberingSM.png';
import organizingSM from '../../content/OrganizingSM.png';
import feelingSM from '../../content/FeelingSM.png';
import behavingSM from '../../content/BehavingSM.png';
import cadeAssessmentSM from '../../content/CADEAssessmentSM.png';

export class NavMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            assessmentId: props.assessmentId,
            cadeMode: props.cadeMode,
            cadeModeFor: props.cadeModeFor,
            cadeDomain: props.cadeDomain,
            personFirstName: props.personFirstName,
            personLastName: props.personLastName, 
            assessmentDate: props.assessmentDate
        }
    }

    render() {
        // The domain in props is ONLY used for the first initialization.  It is set (rightly) to a domain name, not domain.display.  Catch this convert
        let activeKey = this.props.cadeDomain;
        if (activeKey.split(".").length == 1) {
            // Initial time through - change it (and assume display name is the same as the internal name EXCEPT FOR Moving & Sensing and Daily Living - Kludge Alert!!!)
            switch (this.props.cadeDomain) {
                case "MovingSensing":
                    activeKey += ".Moving & Sensing";
                    break;
                case "DailyLiving":
                    activeKey += ".Daily Living";
                    break;
                case "CadeAssessment":
                    activeKey += ".CADE Assessment";
                    break;
                case "CadePartnerAssessment":
                    activeKey += ".CADE PartnerAssessment";
                    break;
                default:
                    activeKey += "." + activeKey;
                    break;
            }
        }

        let isClearClinician = authService.isClearClinician;
        let isRater = authService.isRaterOrCaregiver;

        // Summary title changes per mode
        let summaryNavTitle = null;
        switch (this.state.cadeMode) {
            case "Input":
                summaryNavTitle = "Input Progress";
                break;

            case "Analyze":
                summaryNavTitle = "Analysis Summary";
                break;

            case "Monitor":
                summaryNavTitle = "Overall Progress";
                break;

            case "Report":
                summaryNavTitle = "Generate Report";
                break;

            default:
                summaryNavTitle = "Assessment";
        }

        let noDomainRestrictions = (authService.authenticatedUserRestrictedDomains == null);
        let restrictedDomains = (noDomainRestrictions) ? "" : authService.authenticatedUserRestrictedDomains;

        // Nav marker is either text or a graphic
        return (
            <Fragment>
                {!isRater &&
                    <Link to="/home" ><h2 className="personName personNameLink tour_personName">{this.state.personFirstName} {this.state.personLastName}</h2></Link>
                }
                {isRater &&
                    <h2 className="personName tour_personName">{this.state.personFirstName} {this.state.personLastName}</h2>
                }
                <h4 className="personName ">{this.state.assessmentDate}</h4>
                <Navbar expand="lg" >

                    <Navbar.Toggle />
                    <Navbar.Collapse className={this.props.tourId}>
                        <Nav className="flex-column" defaultActiveKey={activeKey} >

                            <Nav.Item>
                                <Nav.Link eventKey={'Communicating.Communicating'} onSelect={eventKey => { this.props.selectionHandler(eventKey) }} disabled={!(noDomainRestrictions || restrictedDomains.includes("Communicating"))} >
                                    <img className='navDomainLogo' src={communicatingSM} alt='Communicating icon' /> Communicating
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Communicating").type == "text" && this.props.navMarkers.get("Communicating").source > 0 && <span className='nav_navMarkerText'>{this.props.navMarkers.get("Communicating").source}</span>}
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Communicating").type == "image" && <img className='nav_navMarkerImage  tour_pmNavIcon' width={25} src={this.props.navMarkers.get("Communicating").source} alt='' />}
                                </Nav.Link>
                            </Nav.Item>
                     
                            <Nav.Item>
                                <Nav.Link eventKey={'Socializing.Socializing'} onSelect={eventKey => { this.props.selectionHandler(eventKey) }} disabled={!(noDomainRestrictions || restrictedDomains.includes("Socializing"))} >
                                    <img className='navDomainLogo' src={socializingSM} alt='Social icon' /> Socializing
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Socializing").type == "text" && this.props.navMarkers.get("Socializing").source > 0 && <span className='nav_navMarkerText'>{this.props.navMarkers.get("Socializing").source}</span>}
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Socializing").type == "image" && <img className='nav_navMarkerImage' width={25} src={this.props.navMarkers.get("Socializing").source} alt='' />}
                                </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link eventKey={'DailyLiving.Daily Living'} onSelect={eventKey => { this.props.selectionHandler(eventKey) }} disabled={!(noDomainRestrictions || restrictedDomains.includes("DailyLiving"))} >
                                    <img className='navDomainLogo' src={dailyLivingSM} alt='Daily Living icon' /> Daily Living
                                    {this.props.navMarkers != null && this.props.navMarkers.get("DailyLiving").type == "text" && this.props.navMarkers.get("DailyLiving").source > 0 && <span className='nav_navMarkerText'>{this.props.navMarkers.get("DailyLiving").source}</span>}
                                    {this.props.navMarkers != null && this.props.navMarkers.get("DailyLiving").type == "image" && <img className='nav_navMarkerImage' width={25} src={this.props.navMarkers.get("DailyLiving").source} alt='' />}
                                </Nav.Link>
                            </Nav.Item>
                            
                            <Nav.Item>
                                <Nav.Link eventKey={'MovingSensing.Moving & Sensing'} onSelect={eventKey => { this.props.selectionHandler(eventKey) }} disabled={!(noDomainRestrictions || restrictedDomains.includes("MovingSensing"))} >
                                        <img className='navDomainLogo' src={movingSensingSM} alt='Moving and Sensing icon' /> Moving & Sensing
                                        {this.props.navMarkers != null && this.props.navMarkers.get("MovingSensing").type == "text" && this.props.navMarkers.get("MovingSensing").source > 0 && <span className='nav_navMarkerText'>{this.props.navMarkers.get("MovingSensing").source}</span>}
                                        {this.props.navMarkers != null && this.props.navMarkers.get("MovingSensing").type == "image" && <img className='nav_navMarkerImage' width={25} src={this.props.navMarkers.get("MovingSensing").source} alt='' />}
                                    </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link eventKey={'Understanding.Understanding'} onSelect={eventKey => { this.props.selectionHandler(eventKey) }} disabled={!(noDomainRestrictions || restrictedDomains.includes("Understanding"))}>
                                    <img className='navDomainLogo' src={understandingSM} alt='Understanding icon' /> Understanding
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Understanding").type == "text" && this.props.navMarkers.get("Understanding").source > 0 && <span className='nav_navMarkerText'>{this.props.navMarkers.get("Understanding").source}</span>}
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Understanding").type == "image" && <img className='nav_navMarkerImage' width={25} src={this.props.navMarkers.get("Understanding").source} alt='' />}
                                </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link eventKey={'Learning.Learning'} onSelect={eventKey => { this.props.selectionHandler(eventKey) }} disabled={!(noDomainRestrictions || restrictedDomains.includes("Learning"))} >
                                    <img className='navDomainLogo' src={learningSM} alt='Learning icon' /> Learning
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Learning").type == "text" && this.props.navMarkers.get("Learning").source > 0 && <span className='nav_navMarkerText'>{this.props.navMarkers.get("Learning").source}</span>}
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Learning").type == "image" && <img className='nav_navMarkerImage' width={25} src={this.props.navMarkers.get("Learning").source} alt='' />}
                                    </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link eventKey={'Focusing.Focusing'} onSelect={eventKey => { this.props.selectionHandler(eventKey) }} disabled={!(noDomainRestrictions || restrictedDomains.includes("Focusing"))} >
                                    <img className='navDomainLogo' src={focusingSM} alt='Focusing icon' /> Focusing
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Focusing").type == "text" && this.props.navMarkers.get("Focusing").source > 0 && <span className='nav_navMarkerText'>{this.props.navMarkers.get("Focusing").source}</span>}
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Focusing").type == "image" && <img className='nav_navMarkerImage' width={25} src={this.props.navMarkers.get("Focusing").source} alt='' />}
                                </Nav.Link>
                            </Nav.Item>
                            
                            <Nav.Item>
                                <Nav.Link eventKey={'Organizing.Organizing'} onSelect={eventKey => { this.props.selectionHandler(eventKey) }} disabled={!(noDomainRestrictions || restrictedDomains.includes("Organizing"))}>
                                    <img className='navDomainLogo' src={organizingSM} alt='Organizing icon' /> Organizing
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Organizing").type == "text" && this.props.navMarkers.get("Organizing").source > 0 && <span className='nav_navMarkerText'>{this.props.navMarkers.get("Organizing").source}</span>}
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Organizing").type == "image" && <img className='nav_navMarkerImage' width={25} src={this.props.navMarkers.get("Organizing").source} alt='' />}
                                </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link eventKey={'Remembering.Remembering'} onSelect={eventKey => { this.props.selectionHandler(eventKey) }} disabled={!(noDomainRestrictions || restrictedDomains.includes("Remembering"))}>
                                    <img className='navDomainLogo' src={rememberingSM} alt='Memory icon' /> Remembering
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Remembering").type == "text" && this.props.navMarkers.get("Remembering").source > 0 && <span className='nav_navMarkerText'>{this.props.navMarkers.get("Remembering").source}</span>}
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Remembering").type == "image" && <img className='nav_navMarkerImage' width={25} src={this.props.navMarkers.get("Remembering").source} alt='' />}
                                </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link eventKey={'Feeling.Feeling'} onSelect={eventKey => { this.props.selectionHandler(eventKey) }} disabled={!(noDomainRestrictions || restrictedDomains.includes("Feeling"))}>
                                    <img className='navDomainLogo' src={feelingSM} alt='Feelings icon' /> Feeling
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Feeling").type == "text" && this.props.navMarkers.get("Feeling").source > 0 && <span className='nav_navMarkerText'>{this.props.navMarkers.get("Feeling").source}</span>}
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Feeling").type == "image" && <img className='nav_navMarkerImage' width={25} src={this.props.navMarkers.get("Feeling").source} alt='' />}
                                </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link eventKey={'Behaving.Behaving'} onSelect={eventKey => { this.props.selectionHandler(eventKey) }} disabled={!(noDomainRestrictions || restrictedDomains.includes("Behaving"))} >
                                    <img className='navDomainLogo' src={behavingSM} alt='Behaving icon' /> Behaving
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Behaving").type == "text" && this.props.navMarkers.get("Behaving").source > 0 && <span className='nav_navMarkerText'>{this.props.navMarkers.get("Behaving").source}</span>}
                                    {this.props.navMarkers != null && this.props.navMarkers.get("Behaving").type == "image" && <img className='nav_navMarkerImage' width={25} src={this.props.navMarkers.get("Behaving").source} alt='' />}
                                </Nav.Link>
                            </Nav.Item>

                            {isClearClinician && noDomainRestrictions &&
                                <Nav.Item className="tour_navAssessment">
                                <Nav.Link eventKey={'CadeAssessment.CADE Assessment'} onSelect={eventKey => { this.props.selectionHandler(eventKey) }}>
                                    <img className='navDomainLogo' src={cadeAssessmentSM} alt='CADE Assessment' /> {summaryNavTitle}
                                </Nav.Link>
                                </Nav.Item>
                            }
                            {authService.isPartnerProvider && noDomainRestrictions &&
                                <Nav.Item className="tour_navAssessment">
                                <Nav.Link eventKey={'CadePartnerAssessment.CADE PartnerAssessment'} onSelect={eventKey => { this.props.selectionHandler(eventKey) }}>
                                        <img className='navDomainLogo' src={cadeAssessmentSM} alt='CADE User Assessment' /> {summaryNavTitle}
                                    </Nav.Link>
                                </Nav.Item>
                            }
                        </Nav>
                    </Navbar.Collapse>

                </Navbar>
                {!noDomainRestrictions &&
                    <Accordion>
                        <Card>
                            <Card.Header>
                                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                    Want To Learn and Do More?
                                </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <h5> Clear Child CADE Subscriptions</h5>
                                < div className="nav_signupNotice1">
                                    <ul className="nav_signupDetails">
                                        <li>11 assessment domains</li>
                                        <li>Parent Portal access </li>
                                        <li>Mobile ready</li>
                                        <li>Speak to Clear Child Clinicians</li>
                                    </ul>
                                    <p>Learn more about the Clear Child Parent product <strong><a href="https://clearchildparent.com/parent-signup/" target="_blank" title="Clear Child Parent signup">here</a>.</strong></p>
                                    <p>Note:</p>
                                    <p>If you subscribe, in order to continue using this assessment, signup as an <em>existing user</em> and use your current credentials:</p>
                                    <ul className="nav_signupDetails">
                                        <li>Username: {authService.authenticatedUserName}</li>
                                        <li>ID: {authService.authenticatedUserId}</li>
                                    </ul>
                                </div>
                            </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card>
                        <Card.Header>
                            <Accordion.Toggle as={Button} variant="link" eventKey="1">
                                Need Help?
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <p><a href="mailto:support@clearchildpsychology.com" title="support email">Contact us</a> at support@clearchildpsychology.com and we'll do our best to promptly answer your questions!</p>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    </Accordion>
                }
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu/NavMenu.js